import api from "./axios";

export interface ByDayPoint {
  date: string;
  count: number;
}

export interface ScoreBucket {
  label: string;
  count: number;
}

export interface ScoreSummary {
  count: number;
  avg: number | null;
  min: number | null;
  max: number | null;
  buckets: ScoreBucket[];
}

export interface AvailableDevice {
  id: string;
  label: string;
  count: number;
}

export interface DeviceBreakdown {
  id: string;
  label: string;
  patients: number;
  passed: number;
  failed: number;
  pass_rate: number;
  avg_error_deg: number | null;
  models: { label: string; count: number }[];
}

export interface DashboardStats {
  range: { from: string; to: string };
  available_devices: AvailableDevice[];
  by_device: DeviceBreakdown[];
  patients: {
    total: number;
    male: number;
    female: number;
    other: number;
    by_day: ByDayPoint[];
  };
  calibration: {
    passed_patients: number;
    failed_patients: number;
    no_calibration_patients: number;
    pass_rate: number;
    fail_rate: number;
    status_counts: Record<string, number>;
    attempts_to_pass_distribution: Record<string, number>;
    total_attempts: number;
    avg_error_deg_passed: number | null;
    avg_error_deg_all: number | null;
  };
  scores: {
    moca: ScoreSummary;
    qmci: ScoreSummary;
    depression: ScoreSummary;
  };
  details: DashboardPatientDetail[];
}

export interface DashboardPatientDetail {
  patient_id: string | null;
  sex?: string | null;
  age?: number | null;
  created_at?: string | null;
  moca_score?: number | null;
  qmci_score?: number | null;
  depression_score?: number | null;
  calibration_attempts_total: number;
  calibration_passed: boolean;
  calibration_pass_attempt: number | null;
  calibration_status: string | null;
  calibration_statuses: string[];
  calibration_mean_error_deg: number | null;
  device_id: string | null;
  device_label: string | null;
  device_category: string | null;
  passed_parts: number[];
}

export async function getDashboardStats(params: {
  from?: string;
  to?: string;
  devices?: string;
  include_no_calibration?: boolean;
  passed_parts?: string;
}): Promise<DashboardStats> {
  const res = await api.get<DashboardStats>("/stats/dashboard", { params });
  return res.data;
}
